import { createPortal } from "react-dom";

export default function ModalPortalComponent({ children }) {
  return createPortal(children, document.getElementById("portal-root"));
}
